import React, { useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import swal from "sweetalert";
import ListItemIcon from '@mui/material/ListItemIcon';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import SwipeLeftIcon from '@mui/icons-material/SwipeLeft';

const COLORS = ['#2e7d32', '#9c27b0', '#d32f2f'];

const PieChart = ({ totalParticipantCount, totalMaleParticipantCount, totalFemaleParticipantCount }) => {

    const [totalReceiptCollection, setTotalReceiptCollection] = React.useState([]);
    const [totalBankCollection, setTotalBankCollection] = React.useState([]);
    const [totalCashCollection, setTotalCashCollection] = React.useState([]);
    const [totalOnlineCollection, setTotalOnlineCollection] = React.useState([]);


    // const [paindingCollection, setPaindingCollection] = React.useState([]);
    // const [totalParticipantCount, setTotalParticipantCount] = React.useState([]);
    // const [totalMaleParticipantCount, setTotalMaleParticipantCount] = React.useState([]);
    // const [totalFemaleParticipantCount, setTotalFemaleParticipantCount] = React.useState([]);


    const eventid = localStorage.getItem('eventid');


    // useEffect(() => {
    //     axios.get(`api/get-workshop-collection?id=${eventid}`).then(res => {
    //         if (res.status === 200) {


    //             const totalReceipt = res.data.totalReceiptSum;
    //             setTotalReceiptCollection(totalReceipt);

    //             const totalBank = res.data.totalBankSum;
    //             setTotalBankCollection(totalBank);

    //             const totalcash = res.data.totalCashSum;
    //             setTotalCashCollection(totalcash);

    //             const totalonline = res.data.totalOnlineSum;
    //             setTotalOnlineCollection(totalonline)


    //         } else {
    //             swal('Error', "Check API Something Wrong", 'error');

    //         }
    //     })

    // }, []);



    // useEffect(() => {
    //     axios.get(`api/get-workshop-participnat-count?id=${eventid}`).then(res => {
    //         if (res.status === 200) {
    //             const totalParticipanCollections = res.data.totalParticipants;
    //             const maleParticipantCollections = res.data.maleParticipants;
    //             const femaleParticipantCollections = res.data.femaleParticipants;
    //             setTotalParticipantCount(totalParticipanCollections);
    //             setTotalMaleParticipantCount(maleParticipantCollections);
    //             setTotalFemaleParticipantCount(femaleParticipantCollections);

    //         } else {
    //             swal('Error', "Check API Something Wrong", 'error');

    //         }
    //     })

    // }, []);





    //pie chart 
    const pieData = [
        { name: 'totalParticipant', value: 400, description: "Total Participant Is: " + `${totalParticipantCount}` },
        { name: 'maleParticipant', value: 300, description: "Male Participant Is: " + `${totalMaleParticipantCount}` },
        { name: 'femaleParticipant', value: 300, description: "Female Participant Is: " + `${totalFemaleParticipantCount}` },
    ];

    const total = pieData.reduce((acc, curr) => acc + curr.value, 0);
    const [hoveredData, setHoveredData] = useState(null);

    const handleMouseOver = (entry) => {
        setHoveredData(entry);
    };

    const handleMouseOut = () => {
        setHoveredData(null);
    };
    return (
<>
<Box sx={{ width: '100%' }}>
            <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }} marginTop={5}>
                <Grid item xs={12} md={12} lg={12}> 
                    <Typography variant="h6" align="center" gutterBottom>
                        Participant Pie Chart
                    </Typography>
                    <div style={{ width: '100%', height: 300, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <Paper elevation={3}>
                            <svg width={300} height={300}>
                                <circle cx={150} cy={150} r={100} fill="none" stroke="#fff" strokeWidth={2} />
                                {pieData.map((entry, index) => {
                                    const startAngle = index === 0 ? 0 : pieData.slice(0, index).reduce((acc, curr) => acc + (curr.value / total) * 360, 0);
                                    const endAngle = startAngle + (entry.value / total) * 360;
                                    const largeArcFlag = entry.value / total > 0.5 ? 1 : 0;
                                    const [x1, y1] = [150 + 100 * Math.cos(((startAngle - 90) * Math.PI) / 180), 150 + 100 * Math.sin(((startAngle - 90) * Math.PI) / 180)];
                                    const [x2, y2] = [150 + 100 * Math.cos(((endAngle - 90) * Math.PI) / 180), 150 + 100 * Math.sin(((endAngle - 90) * Math.PI) / 180)];
                                    return (
                                        <g key={`group-${index}`} onMouseOver={() => handleMouseOver(entry)} onMouseOut={handleMouseOut}>
                                            <path
                                                key={`path-${index}`}
                                                d={`M ${x1} ${y1} A 100 100 0 ${largeArcFlag} 1 ${x2} ${y2} L 150 150 Z`}
                                                fill={COLORS[index]}
                                            />
                                        </g>
                                    );
                                })}
                                {hoveredData && (
                                    <text x={150} y={150} textAnchor="middle" dominantBaseline="central" fill="white">
                                        {hoveredData.description}
                                    </text>
                                )}
                            </svg>
                        </Paper>
                    </div>
                </Grid>
            </Grid>

        </Box>
</>

        // <Box sx={{ width: '100%' }}>
        //     <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }} marginTop={5}>
        //         <Grid item xs={6}>
        //             <Typography variant="h6" align="center" gutterBottom>
        //                 Participant Pie Chart
        //             </Typography>
        //             <div style={{ width: '100%', height: 300, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        //                 <Paper elevation={3}>
        //                     <svg width={300} height={300}>
        //                         <circle cx={150} cy={150} r={100} fill="none" stroke="#fff" strokeWidth={2} />
        //                         {pieData.map((entry, index) => {
        //                             const startAngle = index === 0 ? 0 : pieData.slice(0, index).reduce((acc, curr) => acc + (curr.value / total) * 360, 0);
        //                             const endAngle = startAngle + (entry.value / total) * 360;
        //                             const largeArcFlag = entry.value / total > 0.5 ? 1 : 0;
        //                             const [x1, y1] = [150 + 100 * Math.cos(((startAngle - 90) * Math.PI) / 180), 150 + 100 * Math.sin(((startAngle - 90) * Math.PI) / 180)];
        //                             const [x2, y2] = [150 + 100 * Math.cos(((endAngle - 90) * Math.PI) / 180), 150 + 100 * Math.sin(((endAngle - 90) * Math.PI) / 180)];
        //                             return (
        //                                 <g key={`group-${index}`} onMouseOver={() => handleMouseOver(entry)} onMouseOut={handleMouseOut}>
        //                                     <path
        //                                         key={`path-${index}`}
        //                                         d={`M ${x1} ${y1} A 100 100 0 ${largeArcFlag} 1 ${x2} ${y2} L 150 150 Z`}
        //                                         fill={COLORS[index]}
        //                                     />
        //                                 </g>
        //                             );
        //                         })}
        //                         {hoveredData && (
        //                             <text x={150} y={150} textAnchor="middle" dominantBaseline="central" fill="white">
        //                                 {hoveredData.description}
        //                             </text>
        //                         )}
        //                     </svg>
        //                 </Paper>
        //             </div>
        //         </Grid>






        //     </Grid>
           
        // </Box>
    );
}

export default PieChart;
